import t, { useRef as N, useState as _ } from "react";
import { useTranslation as A } from "react-i18next";
import b from "classnames";
import { DottedSlider as P } from "../../../../../../features/common/components/sliders/DottedSlider/DottedSlider.js";
import { Selector as R } from "../../../../../../features/common/components/forms/Selector/Selector.js";
import { BookingAvailabilityStatus as S } from "../../../../../../features/api/models/booking/availability/bookingAvailabilityStatus.enum.js";
import { useWindowSize as w } from "../../../../../../features/dom/hooks/useWindowSize.js";
import { tint as D } from "../../../../../../../common/libs/tint.js";
import V from "../../Restaurant/Restaurant.js";
import { StepButton as v } from "../../StepButton/StepButton.js";
import I from "../../../hooks/customization/useCustomization.js";
import { useBookingStep as z, useBooking as F } from "../context.js";
import c from "../bookingForm.module.scss.js";
function Y(a, n) {
  return {
    item: a,
    confirmedHour: a.status === S.PARTIALLY_AVAILABLE ? a.alternativeTimes[0] : n
  };
}
function y({
  idx: a,
  bookingItem: n,
  confirmedHour: u,
  onConfirmedHourChange: B,
  onSubmitClick: g,
  isMobile: i
}) {
  const {
    t: p
  } = A(), {
    configuration: e,
    getTextTranslations: C
  } = I(), r = C("booking"), E = D(5e-3, (e == null ? void 0 : e.design.colors.general.highlightBackground) ?? "#222"), k = n.alternativeTimes.map((l) => ({
    label: l,
    value: l
  })), d = k.find((l) => l.value === u);
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: b({
        [c.desktopListing]: !i
      }),
      style: {
        "--lineColor": (e == null ? void 0 : e.design.colors.general.lines) ?? "#DDD"
      }
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: b({
          [c.listingRestaurant]: !0,
          [c.desktopListing__left]: !i
        })
      },
      /* @__PURE__ */ t.createElement(
        V,
        {
          id: n.id,
          name: n.name,
          phone: n.phone,
          address: n.address,
          accent: (e == null ? void 0 : e.design.colors.general.highlightHighlight) ?? "#EA565C"
        }
      )
    ),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        className: b({
          [c.desktopListing__right]: !i
        })
      },
      n.alternativeTimes.length > 0 && n.status === S.PARTIALLY_AVAILABLE && /* @__PURE__ */ t.createElement(
        R,
        {
          label: (r == null ? void 0 : r.hour) || p("hour"),
          options: k,
          value: d,
          onChange: (l) => B(a, l == null ? void 0 : l.value),
          backgroundColor: E,
          textColor: e == null ? void 0 : e.design.colors.general.highlightText,
          menuPlacement: "auto",
          menuPosition: "fixed",
          menuPortalTarget: document.body
        }
      ),
      !i && g && /* @__PURE__ */ t.createElement("div", { className: c.desktopListing__submit }, /* @__PURE__ */ t.createElement(
        v,
        {
          buttonProps: {
            onClick: () => g(a)
          },
          textColor: e == null ? void 0 : e.design.colors.general.primaryButtonText,
          backgroundColor: e == null ? void 0 : e.design.colors.general.primaryButtonBackground
        },
        (r == null ? void 0 : r.listing_submit) || p("shopLanding.book.listing.submit")
      ))
    )
  );
}
function ee() {
  const a = N(null), {
    t: n
  } = A(), {
    isMobile: u
  } = w(), {
    data: {
      bookingItems: B
    }
  } = z(), {
    back: g,
    form: i,
    setCurrentStep: p
  } = F(), {
    configuration: e,
    getTextTranslations: C
  } = I(), r = C("booking"), [
    E,
    k
  ] = _(0), [
    d,
    l
  ] = _(
    B.map((o) => Y(o, i.hour ?? ""))
  ), H = (o) => {
    k(o);
  }, T = (o, s) => {
    s !== void 0 && l((m) => {
      const f = [];
      for (let h = 0; h < m.length; h += 1) {
        const x = m[h];
        f.push({
          item: x.item,
          confirmedHour: h === o ? s : x.confirmedHour
        });
      }
      return f;
    });
  }, L = (o) => {
    const s = d[o];
    p({
      name: "confirmation",
      data: {
        confirmedHour: s.confirmedHour,
        bookingItem: s.item
      }
    });
  };
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "selection-step", ref: a }, /* @__PURE__ */ t.createElement("div", { className: c.title }, /* @__PURE__ */ t.createElement("i", { onClick: () => g(), className: "lni lni-chevron-left" }), (r == null ? void 0 : r.listing_title) || n("shopLanding.book.listing.title")), u && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    P,
    {
      beforeChange: (o, s) => H(s),
      accentColor: e == null ? void 0 : e.design.colors.general.primaryButtonBackground,
      arrowTextColor: e == null ? void 0 : e.design.colors.general.secondaryButtonText,
      arrowBackgroundColor: e == null ? void 0 : e.design.colors.general.secondaryButtonBackground,
      showArrows: !0
    },
    d.map(({ item: o, confirmedHour: s }, m) => /* @__PURE__ */ t.createElement(
      y,
      {
        key: o.id,
        idx: m,
        bookingItem: o,
        confirmedHour: s,
        onConfirmedHourChange: T,
        isMobile: !0
      }
    ))
  ), /* @__PURE__ */ t.createElement("br", null), /* @__PURE__ */ t.createElement(
    v,
    {
      buttonProps: {
        onClick: () => L(E)
      },
      textColor: e == null ? void 0 : e.design.colors.general.primaryButtonText,
      backgroundColor: e == null ? void 0 : e.design.colors.general.primaryButtonBackground
    },
    (r == null ? void 0 : r.listing_submit) || n("shopLanding.book.listing.submit")
  )), !u && /* @__PURE__ */ t.createElement(t.Fragment, null, d.map(({ item: o, confirmedHour: s }, m) => /* @__PURE__ */ t.createElement(
    y,
    {
      key: o.id,
      idx: m,
      bookingItem: o,
      confirmedHour: s,
      onConfirmedHourChange: T,
      onSubmitClick: L
    }
  ))));
}
export {
  ee as SelectionStep
};
//# sourceMappingURL=SelectionStep.js.map
